
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import ButtonTab from 'vux/src/components/button-tab/button-tab.vue'
import ButtonTabItem from 'vux/src/components/button-tab/button-tab-item.vue'
import Search from 'vux/src/components/search/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import Popup from 'vux/src/components/popup/index.vue'

import axios from 'axios'
export default {
name: 'device',
data () {
return {
devicesdata: [],
rdevicesdata: [],
keyword: '',
showregisted: false,
checkAllFlag: false,
showuploader: false
}
},
watch: { // 实时检测
checkAllFlag (flag) {
var _this = this
this.devicesdata.forEach(function (item, index) {
_this.$set(item, 'checked', _this.checkAllFlag)
item.checked = _this.checkAllFlag
})
}
},
methods: {
getlist: function () {
axios.get('http://localhost:8080/device').then(res => {
this.devicesdata = res.data.jdevices
this.rdevicesdata = res.data.devices
}).catch(function (res) { alert(res) })
}
},
created () {
window.document.title = '保修注册'
this.getlist()
},
components: {
Flexbox,
FlexboxItem,
XButton,
CheckIcon,
Popup,
XHeader,
Scroller,
ButtonTab,
ButtonTabItem,
Search
}
}



// WEBPACK FOOTER //
// ./src/mobile/devicelist.vue